// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__12-3A","image":"Header_image__2VSnL","name":"Header_name__19bwv","info":"Header_info__29LvO","infoRow":"Header_infoRow__2ThiJ"};